export var themeTogglerPropSize=["m","l","s","xs"];export var themeTogglerPropSizeDefault=themeTogglerPropSize[0];
//# sourceMappingURL=types.js.map